export const isOrderSeat = (seat) => 'seatLabel' in seat;
